export * from 'library/async/useAsyncTask';

export enum AsyncTaskState {
  NOT_STARTED,
  IN_PROGRESS,
  ERRORED,
  COMPLETED,
}

interface NotStartedAsyncTask {
  taskState: AsyncTaskState.NOT_STARTED;
}

interface InProgressAsyncTask {
  taskState: AsyncTaskState.IN_PROGRESS;
}

interface ErroredAsyncTask {
  taskState: AsyncTaskState.ERRORED;
  error: {
    message: string;
  };
}

interface CompletedAsyncTaskWithoutResult {
  taskState: AsyncTaskState.COMPLETED;
  result?: unknown;
}

interface CompletedAsyncTaskWithResult<T> {
  taskState: AsyncTaskState.COMPLETED;
  result: T;
}

type CompletedAsyncTask<T = undefined> = CompletedAsyncTaskWithResult<T> & CompletedAsyncTaskWithoutResult;

export type AsyncTask<T = undefined> =
  | NotStartedAsyncTask
  | InProgressAsyncTask
  | ErroredAsyncTask
  | CompletedAsyncTask<T>
  | (T extends undefined ? CompletedAsyncTaskWithoutResult : CompletedAsyncTaskWithResult<T>);
